import React from 'react';
import { Select } from 'antd';
import ReturnInspectionRulesPage from '../../return-inspection/Rules';
import { getCustomerList } from '../../../services/project';

const AdminReturnInspectionRulesPage: React.FC = () => {
  const [customerOptions, setCustomerOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [selectedCustomerId, setSelectedCustomerId] = React.useState<number | undefined>(() => {
    try {
      const url = new URL(window.location.href);
      const qcid = url.searchParams.get('customer_id');
      return qcid ? Number(qcid) : undefined;
    } catch {
      return undefined;
    }
  });

  React.useEffect(() => {
    (async () => {
      try {
        const list = await getCustomerList({ onlyMain: true });
        const opts = Array.isArray(list)
          ? list.map((c: any) => ({ value: Number(c.id), label: `${c.customer_code || c.id || ''} - ${c.name || c.username || ''}` }))
          : [];
        setCustomerOptions(opts);
      } catch {
        setCustomerOptions([]);
      }
    })();
  }, []);

  const handleCustomerChange = (cid?: number) => {
    setSelectedCustomerId(cid);
    try {
      const url = new URL(window.location.href);
      if (cid) url.searchParams.set('customer_id', String(cid));
      else url.searchParams.delete('customer_id');
      // 换客户后，之前选的项目属于另一个客户，必须清掉，避免跨客户串数据
      url.searchParams.delete('project_id');
      window.history.replaceState({}, '', url.toString());
    } catch {}
  };

  return (
    <ReturnInspectionRulesPage
      key={`cid-${selectedCustomerId || 'none'}`}
      adminCustomerId={selectedCustomerId}
      extraFiltersStart={
        <Select
          allowClear
          placeholder="客户（主账号）"
          style={{ width: 320 }}
          value={selectedCustomerId}
          options={customerOptions}
          showSearch
          optionFilterProp="label"
          onChange={(v) => handleCustomerChange(v as number | undefined)}
        />
      }
    />
  );
};

export default AdminReturnInspectionRulesPage;
